import { useQuery } from '@tanstack/react-query';

import { fetchTransactionStartDate, TransactionStartDateResponse } from '../api/member';

export const useTransactionStartDate = (memberId?: number) => {
    return useQuery<TransactionStartDateResponse>({
        queryKey: ['transaction-start-date', memberId],
        queryFn: () => fetchTransactionStartDate(memberId!),
        enabled: !!memberId,
        staleTime: 5 * 60 * 1000, // 5 minutes
        refetchOnWindowFocus: false,
    });
};
